import { push } from "connected-react-router";
import React from "react";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_NEW, LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION, LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION, LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION, ROUTE_PATH } from "../../app/constants";
import { Button } from "../../components/RegularComponents";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";
import TopNavigationBar from "../TopNavigationBar";

const MORTGAGE_APPLICATION_PROPERTY = "hasRequiredEducationCertificate";
export const HasCertificateOfCompletionNovaScotia = (props) => {
  
  //const [applicationSaveError, setApplicationSaveError] = useState(false)

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication ? agentApplication.licencingSubType : LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION;
  const isAssociateBroker = licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  const dispatch = useDispatch();

  
  const handleNext = (hasCertificateOfCompletionNovaScotia) => () => {
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: hasCertificateOfCompletionNovaScotia,
      })
    );

    let noPath = ROUTE_PATH.MRA_COMPLETE_BROKER_EDUCATION 
    let yesPath = ROUTE_PATH.MRA_UPLOAD_CERTIFICATE_EDUCATION

    if(isAssociateBroker) { 
      noPath = ROUTE_PATH.MRA_ASSOCIATE_NOT_HAS_CERTIFICATE
      yesPath = ROUTE_PATH.MRA_ASSOCIATE_UPLOAD_CERTIFICATE_COMPLETION
    }

    // const noPath = !isPrincipalBroker ? (isAssociateBroker ? ROUTE_PATH.MRA_ASSOCIATE_NOT_HAS_CERTIFICATE : ROUTE_PATH.MRA_COMPLETE_BROKER_EDUCATION) : ROUTE_PATH.MRA_COMPLETE_BROKER_EDUCATION;
    // const yesPath = !isPrincipalBroker ? (isAssociateBroker ? ROUTE_PATH.MRA_ASSOCIATE_UPLOAD_CERTIFICATE_COMPLETION : ROUTE_PATH.MRA_UPLOAD_CERTIFICATE_EDUCATION) : ROUTE_PATH.MRA_UPLOAD_CERTIFICATE_EDUCATION;

    dispatch(saveBusinessLicenceApplicationData(
      applicationType, APPLICATION_MODE_NEW))
      .then(data => {
        const nextPath = hasCertificateOfCompletionNovaScotia
          ? yesPath
          : noPath;
        dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`));
      })
      .catch(err => {
        //setApplicationSaveError(true)
      })
  };

  const title = !isPrincipalBroker ?
    `Does the applicant have a certificate of completion from the Nova Scotia ${isAssociateBroker ? 'Associate Mortgage Broker Course': 'Mortgage Broker Education Program'} ?` :
    "Do you have a certificate of completion from the Nova Scotia Mortgage Broker Education Program?"; 

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={applicationType} 
          applicationMode={APPLICATION_MODE_NEW} 
        />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>
            {title}
          </h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className='ns-btn-yes-no'
            buttonType="regular_primary"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3">
          <Button
            className='ns-btn-yes-no'
            buttonType="regular_primary"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
